




















import { defineComponent, computed, reactive } from "@vue/composition-api";

import { CvExperience } from "@/models";

interface Props {
  experience: CvExperience;
}

export default defineComponent({
  name: "cv-experience",
  components: {},
  props: {
    experience: { type: Object, required: true }
  },

  setup(props: Props) {
    const translated = reactive({
      skills: computed(() => props.experience.skills.en.join(", ")),
      roles: computed(() => props.experience.roles.en.join(", "))
    });

    return { translated };
  }
});
